import { useNow } from "@vueuse/core";
import { computed, ref } from "vue";

// Global state for time offset (in milliseconds)
export const timeOffsetMs = ref(0);

window.setTimeOffsetMs = newOffset => { timeOffsetMs.value = newOffset }

// Global function to set the relative time offset
export function setTimeOffset(offsetMs: number) {
  timeOffsetMs.value = offsetMs;
}

// Global function to get the current offset
export function getTimeOffset(): number {
  return timeOffsetMs.value;
}

// Global function to reset to real time
export function resetTimeOffset() {
  timeOffsetMs.value = 0;
}

export const now = ref(new Date())

// Composable that returns the current time adjusted by offset
export function useNowCustom(interval = 1000) {
  const _now = useNow({ interval })

  const now = computed(() => new Date(_now.value.getTime() + timeOffsetMs.value))

  return now;
}
